module.exports = __webpack_public_path__ + "static/img/login-csb.a469c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/login-csb.png
// module id = XWj8
// module chunks = 0